import { GraphQLResult } from 'aws-amplify/api';
import { GetUserQuery, User } from '@/services/API';
import { getUser } from '@/services/graphql/queries';
import { callGraphQLApi } from '@/utils/graphQLAPI';
import { captureSentry } from '@/utils/helpers/sentryHelper';
import { createUserData } from './createUserData';
import { CognitoMetaData } from './getCognitoData';

export async function getOrCreateUserData(
  userID: string,
  cognitoMetaData: CognitoMetaData,
  shouldCreateTemporaryUser: boolean
): Promise<User | null> {
  console.log('Auth | getting user from DB');
  try {
    const gotUser = await callGraphQLApi<GraphQLResult<GetUserQuery>>(getUser, {
      id: userID,
    });
    if (!gotUser.data?.getUser) {
      throw new Error('User not found in DB');
    }
    return gotUser.data?.getUser as User;
  } catch (error) {
    if (error instanceof Error && error.message === 'User not found in DB') {
      //we don't have a user yet, we should create it
      console.log(
        'Auth | user not found in DB shouldCreateTemporaryUser',
        shouldCreateTemporaryUser
      );
      if (!shouldCreateTemporaryUser && cognitoMetaData.isTemporary) return null;
      console.log('Auth | creating user in DB');
      try {
        const user = await createUserData(userID, cognitoMetaData);
        console.log('Auth | user created in DB');
        return user;
      } catch (error) {
        captureSentry({
          title: 'Auth | error creating user in DB',
          error,
        });
        return null;
      }
    } else {
      captureSentry({
        title: 'Auth | Unexpected error getting user from DB',
        error,
      });
      return null;
    }
  }
}
